export default __webpack_public_path__ + "static/l1-contentOne-img-woman-37ab6805f415224cab71defda85adef6.png";